import Chip from '@mui/material/Chip'
import { useIntl } from 'react-intl'
import { Severity } from '../../model/ISystemStatusMessage'
import {
  severityIcon,
  severityToken,
  SEVERITY_LABEL_ID
} from '../../utils/severityTokens'

interface IProps {
  severity: Severity
  muted?: boolean
}

const SeverityChip = ({ severity, muted = false }: IProps) => {
  const intl = useIntl()
  const token = severityToken(severity)
  const Icon = severityIcon(severity)

  return (
    <Chip
      size="small"
      icon={
        <Icon
          sx={{
            fontSize: 14,
            color: `${muted ? '#8B9AA5' : token.chipText} !important`
          }}
        />
      }
      label={intl.formatMessage({ id: SEVERITY_LABEL_ID[severity] })}
      sx={{
        height: 22,
        borderRadius: '11px',
        fontWeight: 500,
        fontSize: 11.5,
        backgroundColor: muted ? '#F4F7F9' : token.bg,
        color: muted ? '#8B9AA5' : token.chipText,
        '& .MuiChip-label': { px: '8px' }
      }}
    />
  )
}

export default SeverityChip
